import { motion } from "framer-motion";
import { useSiteConfig } from "@/context/SiteConfig";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const WhatsAppButton = () => {
  const cfg = useSiteConfig();
  if (!cfg.whatsapp) return null;

  return (
    <motion.a
      href={cfg.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.92 }}
      className="fixed bottom-6 left-6 z-50 w-14 h-14 rounded-full flex items-center justify-center shadow-lg"
      style={{ background: "#25D366", boxShadow: "0 0 24px rgba(37,211,102,0.5)" }}
      aria-label="WhatsApp"
      data-testid="whatsapp-button"
    >
      <span className="absolute inset-0 rounded-full animate-ping" style={{ background: "rgba(37,211,102,0.4)" }} />
      <WhatsAppIcon className="relative w-7 h-7 text-white" />
    </motion.a>
  );
};
